import projectsData from './data/projects.json'

// Statische Projekt-Referenzen (ehemals PocketBase-Collection "projects").
// Quelle: scripts/export-pocketbase-content.mjs; Bilder liegen unter public/content/projects/<id>/.

export type ProjectRecord = (typeof projectsData)[number]

// Neueste zuerst (entspricht dem alten ?sort=-created)
export const projects: ProjectRecord[] = [...projectsData].sort((a, b) => (a.created < b.created ? 1 : -1))

export const getProjectRecordBySlug = (slug: string): ProjectRecord | undefined => projects.find((p) => p.slug === slug)

export const getLastProjectRecords = (limit = 4): ProjectRecord[] => projects.slice(0, limit)

// Kuratierte Auswahl für die Startseite (Reihenfolge = Anzeige-Reihenfolge)
const FEATURED_PROJECT_SLUGS = ['schilderaufsteller', 'freie-wildbahn', 'matchyourfuture', 'patria']

export const getFeaturedProjectRecords = (): ProjectRecord[] =>
  FEATURED_PROJECT_SLUGS.map((slug) => projects.find((p) => p.slug === slug)).filter((p): p is ProjectRecord => Boolean(p))
